import { database, storage } from '../config'
import firebase from 'firebase/app'
const limit = 20

export default class Producto {
    constructor() {
        this.Codigo = ''
        this.Activo = true
        this.Agotado = false
        this.Categoria = ''
        this.Descripcion = ''
        this.Detalle = ''
        this.Img = ''
        this.Marca = ''
        this.Precio = 0
        this.PrecioPuntos = 0
    }

    guardarProducto(producto) {
        // this.db.collection('post').doc('key').set({})
        if(producto.id){
            return database.collection('productos').doc(producto.id).set({
                ...producto,
                Descripcion_lowercase: producto.Descripcion.toLowerCase(),
                Fecha: firebase.firestore.FieldValue.serverTimestamp()
            })
                .then()
                .catch(error => console.error(error))
        }else{
            return database.collection('productos').doc().set({
                ...producto,
                Descripcion_lowercase: producto.Descripcion.toLowerCase(),
                Fecha: firebase.firestore.FieldValue.serverTimestamp()
            })
                .then()
                .catch(error => console.error(error))
        }
        
    }

    subirImagenProducto(file, descripcion, actualizarImgProgress, getImgUrl) {
        const refStorage = storage.ref(`ImgProductos/${descripcion}`)
        const task = refStorage.put(file)
        task.on('state_changed',
            snapshot => {
                const porcentaje = snapshot.bytesTransferred / snapshot.totalBytes * 100
                actualizarImgProgress(porcentaje)
            },
            err => {
                console.error(err.message)
            },
            () => {
                task.snapshot.ref.getDownloadURL()
                    .then(url => {
                        console.log(url)
                        sessionStorage.setItem('imgNewProducto', url)
                        getImgUrl(url)
                    })
                    .catch(err => console.error(err.message))
            })
    }

    buscar(prod) {
        //const tesNode = ReactDOM.findDOMNode(this.refs.productos)
        //window.scrollTo(0, tesNode.offsetTop)
        console.log('buscando ', prod)
        return new Promise((resolve, reject) => 
            database.collection('productos')
                .where('Descripcion_lowercase', '>=', prod.toLowerCase())
                .where('Activo', '==', true)
                .onSnapshot(querySnapshot => {
                    let result = []
                    //console.log('results', querySnapshot.docs)
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().Descripcion_lowercase.includes(prod.toLowerCase())) {
                            result.push(doc)
                        }
                    })

                    resolve(result)
                }),(error => console.error(error))
        )
    }

    eliminar(id) {
        return new Promise((resolve, reject) => {
            database.collection("productos")
                .doc(id)
                .delete()
                .then(result => resolve(result))
                .catch(error => reject(error))
        })
    }

    getProducts(parametros) {
        return new Promise((resolve, reject)=>{
            if(parametros.categoria && parametros.adm){
                database.collection('productos')
                .where("Categoria", "==", parametros.categoria)
                .orderBy(parametros.atributo, parametros.orden)
                .limit(limit)
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(error))
            }
            else if (!parametros.categoria && parametros.adm) {
                database.collection('productos')
                    .orderBy(parametros.atributo, parametros.orden)
                    .limit(limit)
                    .get()
                    .then(querySnapshot => resolve(querySnapshot.docs))
                    .catch(error => reject(error))
            } else if(parametros.categoria){
                database.collection('productos')
                    .where('Activo', '==', true)
                    .where('Categoria', '==', parametros.categoria)
                    .orderBy(parametros.atributo, parametros.orden)
                    .limit(limit)
                    .get()
                    .then(querySnapshot => resolve(querySnapshot.docs))
                    .catch(error => reject(error))
            }else{
                database.collection('productos')
                    .where('Activo', '==', true)
                    .orderBy(parametros.atributo, parametros.orden)
                    .limit(limit)
                    .get()
                    .then(querySnapshot => resolve(querySnapshot.docs))
                    .catch(error => reject(error))
            }
        })
        

    }

    getProductsBack(parametros){
        if (parametros.adm) {
            return database.collection('productos')
                .orderBy(parametros.atributo, parametros.orden)
                .endBefore(parametros.ultimo)
                .limit(20)
                .get()
                .then(querySnapshot => querySnapshot.docs)
                .catch(error => error)
        } else {
            return database.collection('productos')
                .where('Activo', '==', true)
                .orderBy(parametros.atributo, parametros.orden)
                .endBefore(parametros.ultimo)
                .limit(20)
                .get()
                .then(querySnapshot => querySnapshot.docs)
                .catch(error => error)
        }
    }

    getProductsNext(parametros){
        if (parametros.adm) {
            return database.collection('productos')
                .orderBy(parametros.atributo, parametros.orden)
                .startAfter(parametros.ultimo)
                .limit(limit)
                .get()
                .then(querySnapshot => querySnapshot.docs)
                .catch(error => error)
        } else {
            return database.collection('productos')
                .where('Activo', '==', true)
                .orderBy(parametros.atributo, parametros.orden)
                .startAfter(parametros.ultimo)
                .limit(limit)
                .get()
                .then(querySnapshot => querySnapshot.docs)
                .catch(error => error)
        }
    }



    // consultarPostxUsuario(emailUser) {
    //     this.db.collection('post')
    //     .orderBy('fecha', 'asc')
    //     .orderBy('titulo', 'asc')
    //     .where('autor', '==', emailUser)
    //     .onSnapshot(querySnapshot => {
    //         $('#posts').empty()
    //         if (querySnapshot.empty) {
    //             $('#posts').append(this.obtenerTemplatePostVacio())
    //         } else {
    //             querySnapshot.forEach(post => {
    //                 let postHtml = this.obtenerPostTemplate(
    //                     post.data().autor,
    //                     post.data().titulo,
    //                     post.data().descripcion,
    //                     post.data().videoLink,
    //                     post.data().imagenLink,
    //                     Utilidad.obtenerFecha(post.data().fecha.toDate())
    //                 )
    //                 $('#posts').append(postHtml)
    //             })
    //         }
    //     })
    // }




}